import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 计划查询列表
export function getList(params) {
  return request({
    url: URL.rpaRobot.programManagement.taskSchedules,
    method: 'get',
    params
  })
}

// 计划查询新增
export function addOrUpdateRobot(data, requestMethod) {
  return request({
    url: URL.rpaRobot.programManagement.taskSchedule,
    method: requestMethod,
    data
  })
}

